import { css } from 'styled-components';
import * as texts from '@s-group/design-system-tokens/web/tokens/text.es6.js';

const textStyles = ({ variant, sizing, weight, transform, }) => variant &&
    sizing &&
    weight &&
    transform &&
    (transform === 'caption' || transform === 'uppercase')
    ? texts[`SDS_TEXT_${variant}_${sizing}_${weight}_${transform}`.toUpperCase()]
    : variant &&
        sizing &&
        weight &&
        texts[`SDS_TEXT_${variant}_${sizing}_${weight}`.toUpperCase()];
const TextStyle = css `
    ${textStyles}
`;

export { TextStyle };
//# sourceMappingURL=Text.styles.js.map
